import { DataTablePagination, DataTableSearch, Typography, DataTable } from '@ui/components';
import { EmployeeTableDataDto } from '@interfaces/models';
import { useTranslation, Trans } from 'react-i18next';
import { useState } from 'react';

import { RemoveEmployeeDialog } from '../remove-employee-dialog/remove-employee-dialog';
import { EditEmployeeDrawer } from '../edit-employee-drawer/edit-employee-drawer';
import { useImportEmployeesTable } from './use-import-employee-table';

export const ImportEmployeesTable = () => {
  const { t } = useTranslation();

  const [isEditEmployeeDrawerOpen, setIsEditEmployeeDrawerOpen] = useState(false);
  const [isRemoveEmployeeDialogOpen, setIsRemoveEmployeeDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeTableDataDto>();

  const { table, globalFilter, isLoading, columnsLength, totalItems, refetchTable } =
    useImportEmployeesTable({
      onEditEmployee: (employee: EmployeeTableDataDto) => {
        setIsEditEmployeeDrawerOpen(true);
        setSelectedEmployee(employee);
      },
      onRemoveEmployee: (employee: EmployeeTableDataDto) => {
        setIsRemoveEmployeeDialogOpen(true);
        setSelectedEmployee(employee);
      },
    });

  return (
    <div className="bg-table-background rounded-lg overflow-hidden mb-8">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('ONBOARDING.IMPORT_EMPLOYEES.TABLE_TOTAL_EMPLOYEES', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />

          <DataTablePagination
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            prevPageDisabled={!table.getCanPreviousPage()}
            nextPageDisabled={!table.getCanNextPage()}
            prevPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            totalRows={totalItems}
          />
        </div>
      </div>
      <DataTable
        noResultsComponent={
          <Typography variant="labelMediumBook">
            <Trans i18nKey="ONBOARDING.IMPORT_EMPLOYEES.TABLE_NO_RESULTS" />
          </Typography>
        }
        className="max-h-[60vh] overflow-auto"
        columnsLength={columnsLength}
        isLoading={isLoading}
        table={table}
      />

      {selectedEmployee && (
        <EditEmployeeDrawer
          onClose={(data) => {
            if (data?.hasBeenModified) {
              refetchTable();
            }

            setIsEditEmployeeDrawerOpen(false);
          }}
          showRemoveEmployeeDialog={() => setIsRemoveEmployeeDialogOpen(true)}
          isOpen={isEditEmployeeDrawerOpen}
          data={selectedEmployee}
        />
      )}

      {selectedEmployee && (
        <RemoveEmployeeDialog
          onClose={(data) => {
            if (data?.hasBeenModified) {
              refetchTable();
              setIsEditEmployeeDrawerOpen(false);
            }

            setIsRemoveEmployeeDialogOpen(false);
          }}
          isOpen={isRemoveEmployeeDialogOpen}
          employeeId={selectedEmployee?.id}
        />
      )}
    </div>
  );
};
